import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { IconTile, type IconTone, type KitIcon } from "./IconTile";

/**
 * StatTile: one figure that matters, big in Archivo. Label top left, icon tile top right, the figure, then a foot
 * line or a Notches bar. `unit` follows the figure smaller ("/ 25"). `mark` turns the figure seal: use it for the
 * one figure on the page that is the outcome (meetings booked). With `to` the whole tile is a link.
 */
export function StatTile({ label, value, unit, icon, tone = "neutral", foot, mark = false, to, ariaLabel }: { label: string; value: ReactNode; unit?: ReactNode; icon?: KitIcon; tone?: IconTone; foot?: ReactNode; mark?: boolean; to?: string; ariaLabel?: string }) {
  const body = (
    <>
      <span className="stat-tile-top">
        <span className="stat-tile-label">{label}</span>
        {icon && <IconTile icon={icon} tone={tone} size="sm" outline={tone === "neutral" || tone === "ochre"} />}
      </span>
      <span className={`stat-tile-value${mark ? " is-mark" : ""}`}>
        {value}
        {unit && <span className="stat-tile-unit"> {unit}</span>}
      </span>
      {foot && <span className="stat-tile-foot">{foot}</span>}
    </>
  );
  return to ? (
    <Link to={to} className="stat-tile stat-tile-link" aria-label={ariaLabel}>
      {body}
    </Link>
  ) : (
    <div className="stat-tile" aria-label={ariaLabel} role={ariaLabel ? "group" : undefined}>
      {body}
    </div>
  );
}

/** StatRow: the grid that holds StatTiles (four across on a wide screen, two on a tablet, one on a phone). */
export function StatRow({ label, children }: { label: string; children: ReactNode }) {
  return (
    <section className="stat-row" aria-label={label}>
      {children}
    </section>
  );
}
